import checkEnabled from './checkEnabled';

export default (action, menuItems) => {
  return menuItems.filter(menuItem =>
    checkEnabled(action, menuItem.condition) ? menuItem : null
  );
};
